import { useTranslation } from "react-i18next";
export const useLocale = (namespace) => {
   const {i18n,t} =  useTranslation(namespace)
  return{
    i18n,
    t
  }
}
